import React from 'react';
import { Link } from 'react-router-dom';
import { authService } from '../services/authService';
import DismissibleError from './DismissibleError';

const genericMessage = 'If an account matches the provided information, password reset instructions have been sent.';

const ForgotPassword: React.FC = () => {
  const [identifier, setIdentifier] = React.useState('');
  const [loading, setLoading] = React.useState(false);
  const [message, setMessage] = React.useState('');
  const [error, setError] = React.useState('');

  const submit = async (event: React.FormEvent) => {
    event.preventDefault();
    setError('');
    setMessage('');
    if (!identifier.trim()) {
      setError('Username or official email is required.');
      return;
    }
    setLoading(true);
    try {
      const response = await authService.requestPasswordReset(identifier.trim());
      setMessage(response.message || genericMessage);
      setIdentifier('');
    } catch {
      setMessage(genericMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="login-page original-login">
      <section className="login-card" aria-labelledby="forgot-password-title">
        <img className="login-logo" src="/cybershield-logo.png" alt="CyberShield" />
        <h1 id="forgot-password-title">Reset your password</h1>
        <p className="form-intro">Enter your assigned username or official email address.</p>
        {message && <div className="success-message">{message}</div>}
        {error && <DismissibleError message={error} onDismiss={() => setError('')} />}
        <form onSubmit={submit}>
          <div className="form-group">
            <label htmlFor="reset-identifier">Username or official email</label>
            <input
              id="reset-identifier"
              type="text"
              value={identifier}
              onChange={(event) => setIdentifier(event.target.value)}
              autoComplete="username"
              required
            />
          </div>
          <button className="btn btn-primary login-submit" type="submit" disabled={loading}>
            {loading ? 'Sending...' : 'Send reset instructions'}
          </button>
        </form>
        <p className="login-footer"><Link to="/login">Back to login</Link></p>
      </section>
    </main>
  );
};

export default ForgotPassword;
